import { render, staticRenderFns } from "./Hangar.vue?vue&type=template&id=28295652&scoped=true"
import script from "./Hangar.vue?vue&type=script&lang=js"
export * from "./Hangar.vue?vue&type=script&lang=js"
import style0 from "./Hangar.vue?vue&type=style&index=0&id=28295652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28295652",
  null
  
)

export default component.exports